var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventResearch = function SvgEventResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.129,
    height: 51.105
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.109 4.01H39a5.013 5.013 0 0 0-9.823 0h2.076a3.007 3.007 0 0 1 5.67 0h-5.67a3.6 3.6 0 0 0-.172 1.032 3.024 3.024 0 0 0 3.008 3.022 1.008 1.008 0 0 1 0 2.016 5.04 5.04 0 0 1-5.013-5.04 6 6 0 0 1 .1-1.03h-2.109a5.013 5.013 0 0 0-9.823 0h2.076a3.007 3.007 0 0 1 5.67 0h-5.67a3.6 3.6 0 0 0-.172 1.032 3.024 3.024 0 0 0 3.008 3.022 1.008 1.008 0 0 1 0 2.016 5.04 5.04 0 0 1-5.013-5.04 6 6 0 0 1 .1-1.03h-2.106A5.1 5.1 0 0 0 10.226 0a5.1 5.1 0 0 0-4.912 4.01h2.077a3.1 3.1 0 0 1 2.835-2.005 3.1 3.1 0 0 1 2.835 2.005h-5.67a3.6 3.6 0 0 0-.172 1.032 3.024 3.024 0 0 0 3.008 3.022 1.008 1.008 0 0 1 0 2.016 5.04 5.04 0 0 1-5.014-5.04 6 6 0 0 1 .1-1.03H1a1.055 1.055 0 0 0-1 1.061v6.959h44.111V5.071a1.055 1.055 0 0 0-1.002-1.061",
    "data-name": "Path 44838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.11 39.964-4.993-24.963v26.1h4.01a.98.98 0 0 0 .775-.338.94.94 0 0 0 .208-.799",
    "data-name": "Path 44839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 44.17a.954.954 0 0 0 1 .944h10.189l8.137-8.108a8.126 8.126 0 1 1 1.418 1.418l-6.719 6.69h29.084a.954.954 0 0 0 1-.944V14.035H0Zm7.018-27.027h30.076a1.003 1.003 0 0 1 0 2.005H7.018a1.003 1.003 0 1 1 0-2.005m0 5.013h12.03a1.003 1.003 0 1 1 0 2.005H7.018a1.003 1.003 0 1 1 0-2.005",
    "data-name": "Path 44840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.408 36.372a6.015 6.015 0 1 0-1.762-4.254 5.98 5.98 0 0 0 1.762 4.254",
    "data-name": "Path 44841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.961 49.372a1.02 1.02 0 0 0 0 1.432 1 1 0 0 0 .709.3 1.03 1.03 0 0 0 .709-.319l5.646-5.671h-2.836Z",
    "data-name": "Path 44842"
  })))));
};
export default SvgEventResearch;